var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-center mt-3"},[_c('b-col',{attrs:{"lg":"4"}},[_c('journal-edit',{attrs:{"customerId":_vm.customerId,"journalId":_vm.journalId},on:{"done":_vm.back}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }